/**
 * Los software de nóminas que reconoce el flujo de Payfit.
 *
 * Vivía dentro de `Selector/SoftwareSelectorComponent.tsx`, junto a un componente de Chakra que
 * ya no renderizaba nadie: lo montaba `PayfitFileModal`, el V1, borrado con el resto del código
 * muerto. El fichero seguía «vivo» solo porque `PayfitFileModalV2` importaba este enum, y eso
 * bastaba para que el grafo de imports diera por usado un componente que no se pinta nunca.
 *
 * 🔴 Los valores son las cadenas literales, no identificadores. Se usan como `value` de los
 * `<SelectItem>` en `PayfitFileModalV2`, así que cambiarlos cambia lo que se compara en
 * `selectedSoftware === SoftwareHHRR.PAYFIT`. Se copian tal cual, acento incluido.
 */
export enum SoftwareHHRR {
	SELECT = 'Selecciona tu software de nóminas',
	PAYFIT = 'Payfit',
	OTHER = 'Otro'
}
